import * as React from 'react';

function IconPageArrow(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
      <g clipPath="url(#prefix__clip0_11_6013)">
        <path
          d="M11.283 15c-.394 0-.777-.135-1.083-.383l-4.25-3.509a1.417 1.417 0 010-2.216l4.25-3.509a1.75 1.75 0 011.842-.216 1.466 1.466 0 01.875 1.325v7.016a1.466 1.466 0 01-.875 1.325 1.856 1.856 0 01-.759.167z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_11_6013">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

const MemoIconPageArrow = React.memo(IconPageArrow);
export default MemoIconPageArrow;
